module.exports = __webpack_public_path__ + "img/bg-sm-04.7d8d46c2.jpg";